import { createFileRoute } from '@tanstack/react-router';
import { SCIMConfigPage } from '@/components/settings/scim';

export const Route = createFileRoute('/_dashboard/admin/org/scim')({
  component: SCIMSettingsPage,
});

function SCIMSettingsPage() {
  return <SCIMConfigPage />;
}
